
import React from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { ArrowLeft } from "lucide-react";
import { fetchBusinessById } from "@/services/businessService";
import { useQuery } from "@tanstack/react-query";

import BusinessHeader from "@/components/business-detail/BusinessHeader";
import AboutSection from "@/components/business-detail/AboutSection";
import ContactCard from "@/components/business-detail/ContactCard";
import HoursCard from "@/components/business-detail/HoursCard";
import PromotionSection from "@/components/business-detail/PromotionSection";
import BusinessDetailSkeleton from "@/components/business-detail/BusinessDetailSkeleton";
import BusinessDetailError from "@/components/business-detail/BusinessDetailError";
import Footer from "@/components/Footer";

const BusinessDetail = () => {
  const { id } = useParams<{ id: string }>();
  
  const { data: business, isLoading, error } = useQuery({
    queryKey: ['business', id],
    queryFn: () => fetchBusinessById(id as string),
    enabled: !!id,
  });

  const formatDay = (day: string) => {
    return day.charAt(0).toUpperCase() + day.slice(1);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <div className="container py-16">
          <BusinessDetailSkeleton />
        </div>
      </div>
    );
  }

  if (error || !business) {
    return (
      <div className="min-h-screen">
        <Navbar />
        <BusinessDetailError error={error} />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navbar />

      <div className="container py-8">
        <Link to="/businesses" className="inline-flex items-center text-eco-500 hover:text-eco-600 mb-6">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Listings
        </Link>

        <BusinessHeader business={business} />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <AboutSection business={business} />
          </div>

          <div>
            <ContactCard business={business} />
            <HoursCard business={business} formatDay={formatDay} />
          </div>
        </div>
      </div>

      <PromotionSection />
      <Footer />
    </div>
  );
};

export default BusinessDetail;
